export const Props = () => ({
  //Основной цвет
  colorMain: { 
    type: String,
    default: "var(--color-secondary-middle)",
  },

  //Второстепенный цвет
  colorSecondary:{
    type: String,
    default: "var(--color-secondary-light)",
  },

  //Размер иконки
  size: {
    type: Number,
    default: 18,
  }
});